var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"background-template h-100",style:(_vm.getBackgroundCustomization)},[_c('Navbar',{attrs:{"user_email":_vm.user_email}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }